import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-entrymetadata" id="module-storage-entrymetadata"></a>
    <h1 {...{
      "id": "entrymetadata"
    }}>{`EntryMetadata`}</h1>
    <p>{`Metadata for an `}<inlineCode parentName="p">{`Entry`}</inlineCode>{`. It includes useful information such as:`}</p>
    <ul>
      <li parentName="ul">{`size of the file (if a file)`}</li>
      <li parentName="ul">{`date created`}</li>
      <li parentName="ul">{`date modified`}</li>
      <li parentName="ul">{`name`}</li>
    </ul>
    <p>{`Instantiate `}<inlineCode parentName="p">{`EntryMetadata`}</inlineCode>{` by using `}<a parentName="p" {...{
        "href": "./Entry.md#module-storage-entry-getmetadata"
      }}>{`Entry's - getMetadata()`}</a>{`.
In order to instantiate `}<inlineCode parentName="p">{`Entry`}</inlineCode>{`, you will need to first invoke the `}<inlineCode parentName="p">{`localFileSystem`}</inlineCode>{` and then fetch an instance of a File or Folder.`}</p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const fs = require('uxp').storage.localFileSystem;
const folder = await fs.getPluginFolder(); // Gets an instance of Folder (or Entry)
const entryMetaData = await folder.getMetadata();
console.log(entryMetaData.name);
`}</code></pre>
    <a name="module-storage-entrymetadata-name" id="module-storage-entrymetadata-name"></a>
    <h2 {...{
      "id": "name--string"
    }}>{`name : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`The name of the entry.`}</p>
    <a name="module-storage-entrymetadata-size" id="module-storage-entrymetadata-size"></a>
    <h2 {...{
      "id": "size--number"
    }}>{`size : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The size of the entry, if a file. Zero if a folder.`}</p>
    <a name="module-storage-entrymetadata-datecreated" id="module-storage-entrymetadata-datecreated"></a>
    <h2 {...{
      "id": "datecreated--date"
    }}>{`dateCreated : `}<inlineCode parentName="h2">{`Date`}</inlineCode></h2>
    <p>{`The date this entry was created.`}</p>
    <a name="module-storage-entrymetadata-datemodified" id="module-storage-entrymetadata-datemodified"></a>
    <h2 {...{
      "id": "datemodified--date"
    }}>{`dateModified : `}<inlineCode parentName="h2">{`Date`}</inlineCode></h2>
    <p>{`The date this entry was modified.`}</p>
    <a name="module-storage-entrymetadata-isfile" id="module-storage-entrymetadata-isfile"></a>
    <h2 {...{
      "id": "isfile--boolean"
    }}>{`isFile : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Indicates if the entry is a file`}</p>
    <a name="module-storage-entrymetadata-isfolder" id="module-storage-entrymetadata-isfolder"></a>
    <h2 {...{
      "id": "isfolder--boolean"
    }}>{`isFolder : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Indicates if the entry is a folder`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      